export interface LoadingIndicatorPosition {
  left: number;
  top: number;
  angle: number;
}

export const LOADING_INDICATOR_MARGIN_FROM_EDGE = 12;
export const LOADING_INDICATOR_HEIGHT = 32;
export const LOADING_INDICATOR_PADDING = 12;
export const LOADING_INDICATOR_TEXT_GAP = 8;
export const LOADING_INDICATOR_FONT_SIZE = 16;
export const LOADING_INDICATOR_BORDER_RADIUS = 20;
export const LOADING_INDICATOR_CIRCULAR_PROGRESS_DIAMETER = 20;
export const LOADING_INDICATOR_CIRCULAR_PROGRESS_BASE_DIAMETER = 16;
export const LOADING_INDICATOR_POSITION_BUFFER = 15;
export const LOADING_INDICATOR_TEXT_FIT_BUFFER = 12;
